/**
 * Accordion
 */

jQuery(document).ready(function($) {

    const ENTER = 13;
    const SPACE = 32;

    function toggleItem($control) {
        let $details = $('#' + $control.attr('aria-controls'));
        let $item = $control.closest('.js-accordion-item');
        $item.toggleClass('is-expanded'); // Toggle is-expanded class on $item
        if ( $item.hasClass('is-expanded') ) {
            $details.slideDown(300, function() {
                $control.attr('aria-expanded', 'true');
                $details.attr('aria-hidden', 'false');
            });
            $item.siblings().each(function() { // Collapse any other accordion items
                let $item = $(this);
                let $control = $item.find('.js-accordion-control');
                let $details = $('#' + $control.attr('aria-controls'));
                $item.removeClass('is-expanded');
                $details.slideUp(300, function() {
                    $control.attr('aria-expanded', 'false');
                    $details.attr('aria-hidden', 'true');
                });
            });
        } else {
            $details.slideUp(300, function() {
                $control.attr('aria-expanded', 'false');
                $details.attr('aria-hidden', 'true');
            });
        }
    }
    
    const $controls = $('.js-accordion-control');
    $controls.on('click', function(event) {
        event.preventDefault();
        toggleItem($(this));
    });
    $controls.on('keydown', function(event) {
        if ( event.which === ENTER || event.which === SPACE ) {
            event.preventDefault();
            toggleItem($(this));
        }
    });
    
});
